import { loader, switchMap, tap } from 'rxjs-operators';
import apiService from './api';
import tokenService, { TokenService } from './token';
import authService from 'services/auth';
import { ACCOUNT_PARTNER, ACCOUNT_ENV, ADMIN_URL_NEW } from '../settings';
import { IAuth } from 'interfaces/IAuth';
import rxjsOperators from 'rxjs-operators';
import { from, of } from 'rxjs';
import userService from './user';
import { ILoginResponse } from 'interfaces/loginResponse';
import { productNewService } from './productNewService';
import { cookieService } from './cookieService';
export const LOGGED_USER_ACCOUNT_ID = 'sun_admin_logged_user_id';

export class LoginService {
  constructor(private tokenService: TokenService) {
    this.login();
  }

  public login() {
    const login$ = from(this.loginAsPromise());

    const idAlreadyLogged = cookieService.getCookie(LOGGED_USER_ACCOUNT_ID);
    const alreadyRedirected = Boolean(cookieService.getCookie('isRedirected'));

    login$
      .pipe(
        loader(),
        switchMap(token =>
          apiService.post<ILoginResponse>('/auth/login', {
            token
          })
        ),
        tap(({ accounts }) => {
          if (accounts?.length > 1 && !alreadyRedirected) {
            const adminV2URL = new URL(window.location.href);

            if (adminV2URL.searchParams.has('accounts_token')) {
              adminV2URL.searchParams.delete('accounts_token');
            }

            window.location.href = `${ADMIN_URL_NEW}/?redirectTo=${adminV2URL}`;
            return;
          }
        }),
        switchMap(({ token, refresh, photo, accounts }) => {
          userService.setAccounts(accounts);
          this.tokenService.setTokens({ token, refresh });
          if (accounts?.length > 1 && alreadyRedirected && idAlreadyLogged) {
            return this.switchAccount(Number(idAlreadyLogged));
          }

          authService.setUserPhoto(photo);
          productNewService.openProductDrawerByParam();

          return of(true);
        })
      )
      .subscribe(
        () => {},
        (err: unknown) => {
          console.error('Login Error', err);
        }
      );
  }

  public switchAccount(userIdToAccess: number) {
    return userService.getAccounts().pipe(
      rxjsOperators.take(1),
      rxjsOperators.filter(accounts => {
        const accountLogged = accounts.find(account => account.isMe);

        return userIdToAccess !== accountLogged.id;
      }),
      rxjsOperators.tap(() => cookieService.setCookie(LOGGED_USER_ACCOUNT_ID, String(userIdToAccess))),
      rxjsOperators.switchMap(() =>
        apiService
          .post<IAuth>('/auth/switchaccount', { userIdToAccess })
          .pipe(
            rxjsOperators.loader(),
            rxjsOperators.filter(data => Boolean(data.token)),
            rxjsOperators.tap(data => {
              this.tokenService.setTokens(data);
            })
          )
      ),
      rxjsOperators.tap(() => {
        productNewService.refreshProducts();
      })
    );
  }

  private loginAsPromise() {
    return new Promise<string>(resolve => {
      (window as any).Eduzz.Accounts.login(ACCOUNT_PARTNER, {
        partner: true,
        env: ACCOUNT_ENV
      }).subscribe(resolve);
    });
  }
}

const loginService = new LoginService(tokenService);
export default loginService;
